<template>
  <div class="table-appaltante shadow-lg p-3 mb-5 bg-white card p-3">
    <TableView :columns="columns" :items="questions" :pagination="pagination" :sort-field="sortField"
      :sort-direction="sortDirection" @page-change="$emit('page-change', $event)" @sort="$emit('sort', $event)">
      <!-- Codice -->
      <template #id="{ item }">
        {{ item.id }}
      </template>

      <!-- Data -->
      <template #created_at="{ item }">
        {{ formatDate(item.created_at) }}
      </template>

      <!-- Argomenti 
      <template #topics="{ item }">
        <div v-if="item.topics && item.topics.length">
          {{item.topics.map(t => t.title).join(', ')}}
        </div>
        <div v-else>-</div>
      </template>-->

      <!-- Articoli -->
      <!--<template #articles="{ item }">
        <div v-if="item.articles && item.articles.length">
          {{item.articles.map(a => `Articolo ${a.id}`).join(', ')}}
        </div>
        <div v-else>-</div>
      </template>-->

      <template #articles="{ item }">
        <div v-if="item.articles && item.articles.length">
          <template v-for="(a, idx) in item.articles" :key="a.id">
            <span :title="a.title || ''">{{ a.title ? formatArticleTitle(a.title) : `Art. ${a.id}` }}</span>
            <span v-if="idx < item.articles.length - 1">, </span>
          </template>
        </div>
        <div v-else>-</div>
      </template>

      <!-- Oggetto -->
      <template #object="{ item }">
        <div class="td-object">
          {{ item.object }}
        </div>
      </template>

      <!-- Stato Quesito -->
      <template #state_id="{ item }">
        <div class="td-state">
          <span class="badge-status w-100" :class="getBadgeClass(item)">
            {{ getStateLabel(item) }}
          </span>
        </div>
      </template>

      <!-- Azioni -->
      <template #actions="{ item }">
        <button class="btn btn-sm" @click="$emit('open-detail', item)" title="Visualizza dettaglio quesito"
          data-bs-toggle="tooltip" data-bs-placement="top">
          <i class="bi bi-eye"></i>
        </button>
      </template>

      <template #empty>Nessun elemento trovato.</template>
    </TableView>
  </div>
</template>

<script>
import TableView from '../../../../components/common/TableView.vue';

export default {
  name: 'AppaltanteTable',
  components: { TableView },
  props: ['questions', 'pagination', 'sortField', 'sortDirection'],
  data() {
    return {
      columns: [
        { key: 'id', label: 'Codice identificativo', sortable: true, headerClass: 'bg-primary text-white' },
        { key: 'created_at', label: 'Data', sortable: true, headerClass: 'bg-primary text-white' },
        { key: 'articles', label: 'Articoli', headerClass: 'bg-primary text-white' },
        { key: 'object', label: 'Oggetto', sortable: false, headerClass: 'bg-primary text-white' },
        { key: 'state_id', label: 'Stato Quesito', headerClass: 'bg-primary text-white' }
      ]
    };
  },
  methods: {
    formatDate(dateString) {
      if (!dateString) return '-';
      const date = new Date(dateString);
      return date.toLocaleDateString('it-IT');
    },
    formatArticleTitle(title) {
      if (!title) return '';

      // Caso "Art. <numero> ..."
      const artDotMatch = title.match(/^Art\.\s*(\d+)/i);
      if (artDotMatch) {
        return `Art.${artDotMatch[1]}`;
      }

      // Caso "Articolo <numero> ..."
      const articoloMatch = title.match(/^Articolo\s+(\d+)/i);
      if (articoloMatch) {
        return `Articolo ${articoloMatch[1]}`;
      }

      // Altrimenti titolo completo
      return title;
    },
    getStateLabel(item) {
      if (item.state_id === 'ASSEVERATO' && item.published) {
        return 'Parere Pubblicato';
      }

      const map = {
        INVIATO: 'Quesito Inviato',
        ASSEGNATO: 'Quesito Assegnato',
        EVASO: 'Risposta Evasa',
        ASSEVERATO: 'Risposta Asseverata',
        NON_ASSEVERATO: 'Risposta Non Asseverata',
        IN_LAVORAZIONE: 'Quesito Assegnato'
      };

      return map[item.state_id] || item.state_id;
    },

    getBadgeClass(item) {
      if (item.state_id === 'ASSEVERATO' && item.published) {
        return 'bg-dark-blue';
      }

      const colors = {
        INVIATO: 'bg-secondary',
        ASSEGNATO: 'bg-primary',
        EVASO: 'bg-mandarino',
        ASSEVERATO: 'bg-success',
        NON_ASSEVERATO: 'bg-danger',
        IN_LAVORAZIONE: 'bg-primary'
      };

      return colors[item.state_id] || 'bg-light text-dark';
    }
  }
};
</script>

<style scoped>
.table-appaltante table th:nth-child(1) {
  width: 10%;
}

.table-appaltante table th:nth-child(2) {
  width: 10%;
}

.table-appaltante table th:nth-child(3) {
  width: 25%;
}

.table-appaltante table th:nth-child(4) {
  width: 30%;
}

.table-appaltante table th:nth-child(5),
.table-appaltante table td:nth-child(5) {
  width: 15%;
}

.table-appaltante table th:nth-child(6) {
  width: 10%;
}

/* --- BADGE STYLE --- */
.td-state {
  display: flex;
  align-items: center;
  justify-content: center;
}

.td-object {
  display: flex;
  align-items: center;
  justify-content: center;
}

.badge-status {
  display: inline-block;
  text-align: center;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  width: 80%;
  max-width: 80%;
  text-align: center;
  padding: 0.5rem 0.75rem;
  border-radius: 0.4rem;
  font-weight: 600;
  color: #fff !important;
  /*text-transform: uppercase;*/
  letter-spacing: 0.3px;
}

/* colori personalizzati */
.bg-dark-blue {
  background-color: #002b80 !important;
}

.bg-mandarino {
  background-color: #ff9b42 !important;
}

.bg-info {
  background-color: #0dcaf0 !important;
}

.table-appaltante ::v-deep(thead th) {
  background-color: #0066cc !important;
  color: #fff !important;
  text-align: center;
}

.table-appaltante table {
  font-size: 0.8rem !important;
  table-layout: fixed;
  width: 100%;
}


.table-appaltante ::v-deep(th.sorted .sort-icon) {
  color: #fff !important;
}


.table-appaltante table thead th,
.table-appaltante table tbody td {
  padding: 0.4rem 0.6rem !important;
}

.table-appaltante ::v-deep(table thead th) {
  background-color: #0066cc !important;
  color: #fff !important;
  text-align: center;
}

.table-appaltante table th {
  width: auto;
  min-width: 80px;
}

.table-appaltante table th .sort-icon {
  display: inline-block;
  width: 1em;
  text-align: center;
}

.table-appaltante ::v-deep(th.sorted .sort-icon) {
  opacity: 1 !important;
  color: #fff !important;
}

.table-appaltante ::v-deep(th.sortable .sort-icon) {
  color: #fff !important;
}

.table-appaltante ::v-deep(.modern-table) {
  font-size: 0.85rem;
  /* corpo tabella più piccolo */
}

.table-appaltante ::v-deep(.modern-table thead th) {
  font-size: 0.8rem !important;
  /* header più piccolo */
  padding: 0.5rem 0.6rem !important;
}

.table-appaltante ::v-deep(.modern-table tbody td) {
  font-size: 0.8rem !important;
  /* corpo cella più piccolo */
  padding: 0.4rem 0.6rem !important;
}
</style>
